import React from "react";
import { IOrder } from "../../../types/orders";

const TableTooltipOrderNumbers: React.FC<{ order: IOrder }> = ({ order }) => {
    return (
        <div className="bg-white shadow-banner p-2 min-w-[80px] rounded-[4px]">
            {
                !!order.orderNumbers && order.orderNumbers.map((oN, j) => {
                    return (
                        <div className="mb-1" style={{ lineHeight: '12px' }} key={j}>
                            Order Number: {oN} - TradingPartner: {order.tradingPartnerName} - CustomerCode: {order.tmsCustomerCode}
                        </div>
                    )
                })
            }
        </div>
    )
}

export default TableTooltipOrderNumbers;